import { Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"

export const PricePerPersonPlaceholderModel = types.model("PricePerPersonPlaceholder").props({
  price: types.number,
  adults: types.number,
  children: types.number,
})

export type PricePerPersonPlaceholder = Instance<typeof PricePerPersonPlaceholderModel>
export type PricePerPersonPlaceholderSnapshotOut = SnapshotOut<
  typeof PricePerPersonPlaceholderModel
>
export type PricePerPersonPlaceholderSnapshotIn = SnapshotIn<typeof PricePerPersonPlaceholderModel>
